import React, { useState, useEffect } from 'react';
import {
  node, arrayOf, oneOfType, string, shape, bool
} from 'prop-types';
import useAxios from 'axios-hooks';
import {
  Router as ReactBrowserRouter,
} from 'react-router-dom';
import { useRoute } from '../hooks/useRoute';
import RouterContext from '../RouterContext';

const stringifyParams = (params) => {
  return Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');
};

const BrowserRouter = ({ children, experience, history, disableCrossExpCheck }) => {

  const [path, setPath] = useState(null);
  const [pathHistory, setPathHistory] = useState(
    [history?.location?.pathname]
  );

  const [{ data, loading }, execute] = useAxios(path, { manual: true });

  useRoute({ history });

  useEffect(() => {
    // if the experience does not provide `experience`
    // its opting out of checking cross exp functionality
    if (!experience || disableCrossExpCheck) return () => {};

    return history.listen((location) => {
      const loc = location.pathname + location.search;
      setPath(loc);
      setPathHistory((paths) => [...paths, loc]);
      setTimeout(() => {
        const headers = {
          'x-rules-engine': 'query'
        };
        execute({ url: `${loc}`, headers });
      }, 0);
    });
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      const loc = location.pathname + location.search;
      setPathHistory((paths) => [...paths, loc]);
    });
  }, []);

  useEffect(() => {

    if (data && experience && path) {
      const [_path, queryString = ''] = path.split('?');

      const params = queryString.split('&')
        .filter((value) => value)
        .reduce((acc, cur) => {
          const [key, value] = cur.split('=');
          return {
            ...acc,
            [key]: value,
          };
        }, {});
      const experienceName = data.experience;
      // an empty string may be present if its forced
      // and dont want it to redirect in that case
      if (typeof experienceName !== 'undefined') {
        if (experienceName !== experience && experienceName) {
          const url = `${_path}?${stringifyParams(params)}`;
          window.location.replace(url);
        }
      } else if (path) {
        const url = `${_path}?${stringifyParams(params)}`;
        window.location.replace(url);
      }
    }
  }, [data, experience, loading]);

  const contextValue = {
    paths: pathHistory
  };

  return (
    <ReactBrowserRouter history={history}>
      <RouterContext.Provider value={contextValue}>
        {children}
      </RouterContext.Provider>
    </ReactBrowserRouter>
  );
};

BrowserRouter.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  history: shape({}).isRequired,
  /**
   * The current nucleus experience. This is used to call full page reloads
   * when there is a pushState or replaceState SPA transition.
   *
   * Leave null to prevent window.location change on SPA transitions cross experience
   */
  experience: string,
  disableCrossExpCheck: bool,
};

BrowserRouter.defaultProps = {
  experience: null,
  disableCrossExpCheck: false
};
export { BrowserRouter };
